import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
@Injectable()
export class DatePickerFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!!date)
      return `${date.day.toString().padStart(2, '0')}/${date.month.toString().padStart(2, '0')}/${date.year}`;
    return '';
  }
}
